import { render, staticRenderFns } from "./MelonPics.vue?vue&type=template&id=55020140&scoped=true&"
import script from "./MelonPics.vue?vue&type=script&lang=js&"
export * from "./MelonPics.vue?vue&type=script&lang=js&"
import style0 from "./MelonPics.vue?vue&type=style&index=0&id=55020140&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55020140",
  null
  
)

export default component.exports